import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const IconCircle = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9.5" stroke="#b8a98a" strokeWidth="2"/></svg>
);
const IconSquare = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="4" y="4" width="16" height="16" rx="3" stroke="#b8a98a" strokeWidth="2"/></svg>
);
const IconRect = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="4" y="8" width="16" height="8" rx="2" stroke="#b8a98a" strokeWidth="2"/></svg>
);
const IconGrid = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="4" y="4" width="16" height="16" rx="3" stroke="#b8a98a" strokeWidth="2"/><path d="M4 12H20" stroke="#b8a98a" strokeWidth="2"/><path d="M12 4V20" stroke="#b8a98a" strokeWidth="2"/></svg>
);
const IconDiamond = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="6" y="6" width="12" height="12" rx="2" transform="rotate(45 12 12)" stroke="#b8a98a" strokeWidth="2"/></svg>
);
const ArrowSvg = () => (
  <svg width="22" height="22" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft: 12}}>
    <path d="M10 7L18 14L10 21" stroke="#b8a98a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const cardData = [
  {
    title: 'Choose Vibes',
    description: 'Catch the vibe — let’s roll!',
    icon: <IconCircle />,
    recommend: true,
  },
  {
    title: 'Style',
    description: 'Your preferred fashion style.',
    icon: <IconSquare />,
  },
  {
    title: 'Occasion',
    description: 'What is the event or scenario?',
    icon: <IconCircle />,
  },
  {
    title: 'Body Type',
    description: 'Highlight your unique shape.',
    icon: <IconRect />,
  },
  {
    title: 'Weather',
    description: 'Adapt to the climate.',
    icon: <IconGrid />,
  },
  {
    title: 'Find Matches',
    description: 'Find items that fit your vibe.',
    icon: <IconDiamond />,
  },
];

const MobileMyStylistPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = 'auto';
  }, []);

  const handleCardClick = (title: string) => {
    // Vibes 先跳转到小球界面
    if (title === 'Choose Vibes') {
      navigate('/vibe-selection');
      return;
    }
    // 其他类型保持原有逻辑
    let path: string;
    switch (title) {
      case 'Style':
        path = 'style';
        break;
      case 'Occasion':
        path = 'occasion';
        break;
      case 'Body Type':
        path = 'body-type';
        break;
      case 'Weather':
        path = 'weather';
        break;
      case 'Find Matches':
        path = 'find-match';
        break;
      default:
        path = 'style';
    }
    navigate('/chatpage', { state: { path } });
  };

  return (
    <div className="my-stylist-page mobile-optimized">
      <h2>Discover Your Style</h2>
      <div className="card-list">
        {cardData.map((card) => (
          <div 
            className={`card-item${card.recommend ? ' highlight' : ''}`} 
            key={card.title}
            onClick={() => handleCardClick(card.title)}
          >
            {card.icon && <span className="card-icon">{card.icon}</span>}
            <div className="card-content">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
            <ArrowSvg />
            {card.recommend && <span className="recommend-label">Recommend</span>}
          </div>
        ))}
      </div>
      <div className="attraction-booster" onClick={() => navigate('/chatpage', { state: { path: 'attraction' } })}>
        <strong>Attraction Booster</strong>
        <p>Like him/her? Showcase the side you both love.</p>
      </div>
    </div>
  );
};

export default MobileMyStylistPage; 